<template>
  <div class="d-inline-block">
    <v-dialog v-model="dialog" scrollable max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" icon small v-bind="attrs" v-on="on">
          <v-icon small>mdi-help-circle-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>Traditional Pregnancy Risk Categories</v-card-title>
        <v-card-text>
          <b>Note: </b>The former pregnancy risk category system (letters
          A,B,C,D,X) was replaced by the FDA in 2015, as these designations were
          considered to be overly simplified and a potential source of
          confusion.<br />

          Prescription drugs submitted to the FDA after June 30, 2015
          <i>will not use the 5 letter designations</i>, and older drugs will be
          gradually phased out of this system.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <div class="my-1 pa-1" :class="{ highlight: preg_letter == 'A' }">
            <span class="font-weight-bold">Category A:</span> The possibility of
            fetal harm appears remote. Extremely few drugs exist in this
            category (e.g. multi vitamins).
          </div>

          <div class="my-1 pa-1" :class="{ highlight: preg_letter == 'B' }">
            <span class="font-weight-bold">Category B:</span> If there is a
            clinical need for a drug in this category they are considered safe
            to use.
            <span class="example">Examples: acetaminophen, amoxicillin.</span>
          </div>

          <div class="my-1 pa-1" :class="{ highlight: preg_letter == 'C' }">
            <span class="font-weight-bold">Category C:</span> These drugs should
            be given only if the potential benefit justifies the potential risk
            to the fetus.
            <span class="example"
              >Examples: fluoroquinolones, gentamicin, saccharin, aspirin.</span
            >
          </div>

          <div class="my-1 pa-1" :class="{ highlight: preg_letter == 'D' }">
            <span class="font-weight-bold">Category D:</span> There is positive
            evidence of human fetal risk, but the benefits from use in pregnant
            women may be acceptable despite the risk. They should only be used
            in pregnancy when the alternatives are worse.
            <span class="example"
              >Examples: tetracyclines, ACE inhibitors, most
              antineoplastics</span
            >.
          </div>

          <div class="my-1 pa-1" :class="{ highlight: preg_letter == 'X' }">
            <span class="font-weight-bold">Category X:</span> The risk of use of
            the drug in pregnant women clearly outweighs any possible benefit.
            The drug is contraindicated in women who are, or may become
            pregnant.
            <span class="example"
              >Examples: thalidomide, oral contraceptives, statins (e.g. Lipitor
              ®)</span
            >.
          </div>
          <v-divider class="mt-2"></v-divider>
          <div>
            <div class="overline">References</div>
            <ul>
              <li>
                <a
                  href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4989726/"
                  target="_self"
                >
                  Drugs in Pregnancy and Lactation. 8th Ed. Briggs GG, Freeman
                  RK, Yaffe SJ Editors. Wolters Kluwer Health. Philadelphia.
                  2008.</a
                >
              </li>
              <li>
                <a
                  href="https://www.fda.gov/drugs/labeling-information-drug-products/pregnancy-and-lactation-labeling-drugs-final-rule"
                  target="_blank"
                  >FDA: Pregnancy and Lactation Labeling (Drugs) Final Rule</a
                >
              </li>
              <li>
                <a
                  href="https://www.drugs.com/fda-consumer/pregnant-breastfeeding-better-drug-information-is-coming-334.html"
                  target="_blank"
                  >Drugs.com: Pregnant? Breastfeeding? Better Drug Information
                  Is Coming
                </a>
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "PregnancyClassInfo",
  props: {
    preg_letter: null,
  },
  data: function() {
    return {
      dialog: false,
    };
  },
  methods: {},
  computed: {
    buttonTitle: function() {
      let title = "Pregnancy Classes";
      if (this.preg_letter) title = "Class " + this.preg_letter;
      return title;
    },
  },
};
</script>

<style scoped>
.example {
  font-size: smaller;
  font-style: italic;
}
.highlight {
  background-color: #fbffc4;
}
</style>
